import Vue from 'vue';

const defaultDiagnostics = {
  handleIntervalsCallCount: 0,
  handledTickCount: 0,
  missedTickCount: 0,
  skippedMilliseconds: 0,
  sumRuntime: 0,
  maxRuntime: 0,
  workerTicks: 0,
};

let lastDiagnosticNow = null;
let diagnostics = { ...defaultDiagnostics };

let worker = new Worker('/worker.js');

const activeIntervals = [];
let timeoutId = null;
let nextExpectedNow = 0;

function handleIntervals() {
  const nowBefore = Date.now();

  diagnostics.handleIntervalsCallCount += 1;

  let realDiff = nowBefore - nextExpectedNow;
  if (realDiff < 0) {
    realDiff = 0;
  }

  if (realDiff < 10000) {
    let loopsInThisInterval = 0;
    while (nextExpectedNow <= Date.now()) {
      nextExpectedNow += 5;

      loopsInThisInterval += 1;

      if (loopsInThisInterval < 2000) {
        diagnostics.handledTickCount += 1;

        for (const interval of activeIntervals) {
          interval.expireCounter += 5;
          if (interval.expireCounter >= interval.milliseconds) {
            interval.expireCounter = 0;
            //for(let i=0; i<4; i++) 
              interval.handler(null);
          }
        }
      } else {
        diagnostics.missedTickCount += 1;
      }
    }
  } else {
    diagnostics.skippedMilliseconds += realDiff;

    for (const interval of activeIntervals) {
      const handlerDiff = Math.floor(realDiff / interval.milliseconds) * interval.milliseconds;
      interval.expireCounter = (realDiff - handlerDiff);
      interval.handler(handlerDiff);
    }

    nextExpectedNow = nowBefore + 5;
  }

  const nowAfter = Date.now();

  const runtime = nowAfter - nowBefore;
  diagnostics.sumRuntime += runtime;
  if (diagnostics.maxRuntime < runtime) {
    diagnostics.maxRuntime = runtime;
  }

  let milliseconds = nextExpectedNow - nowAfter;
  if (milliseconds < 0) {
    milliseconds = 0;
  }

  if (Math.floor(lastDiagnosticNow / 1000) !== Math.floor(nowBefore / 1000)) {
    diagnostics.timeDiff = (nowBefore - lastDiagnosticNow);

    // global.console.log(diagnostics);
    lastDiagnosticNow = nowBefore;
    diagnostics = { ...defaultDiagnostics };
  }
}

worker.onmessage = function() {
  diagnostics.workerTicks += 1;
  handleIntervals();
};

function rescheduleIntervals() {
  if (activeIntervals.length !== 0) {
    if (timeoutId == null) {
      nextExpectedNow = Date.now() + 5;
      lastDiagnosticNow = Date.now();
      diagnostics = { ...defaultDiagnostics };
    }
  }
}

const state = new Vue({
  data: () => ({
    asyncJobCount: 0,
    token: null,
    simulations: [],
    simulationsLoaded: false,
    simulationsPromise: null,
    abortMessage: null,
    abortMessageIsVisible: false,
  }),

  methods: {
    runAsync(fn) {
      async function runner() {
        state.asyncJobCount += 1;

        try {
          return await fn();
        } finally {
          state.asyncJobCount -= 1;
        }
      }

      return runner().then(null, err => {
        global.console.error(err);
      });
    },

    async performJsonRpc(method, params) {
      const request = {
        jsonrpc: '2.0',
        id: 1,
        method,
        params,
      };

      const httpResponse = await fetch('/api/v1/jsonrpc', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!httpResponse.ok) {
        throw new Error(`JSON-RPC API responded with HTTP status ${httpResponse.status}`);
      }

      const response = await httpResponse.json();
      if (response.error) {
        throw new Error(response.error.message);
      }

      return response.result;
    },

    setInterval(handler, milliseconds) {
      if ((milliseconds % 5) !== 0) {
        throw new Error(`Interval must be multiple of 5 milliseconds`);
      }

      const intervalId = {};

      activeIntervals.push({
        intervalId,
        handler,
        milliseconds,
        expireCounter: 0,
      });

      rescheduleIntervals();

      return intervalId;
    },

    setTimeout(handler, milliseconds) {
      if (milliseconds > 0) {
        let handlerDidRun = false;
        let intervalId = state.setInterval((...args) => {
          if (!handlerDidRun && handler) {
            handler(...args);
            handlerDidRun = true;
          }
          if (intervalId) {
            state.clearInterval(intervalId);
            intervalId = null;
          }
        }, milliseconds);
      } else if (handler) {
        handler(0);
      }
    },

    clearInterval(intervalId) {
      const index = activeIntervals.findIndex(interval => {
        return (interval.intervalId === intervalId);
      });

      if (index >= 0) {
        activeIntervals.splice(index, 1);
      }

      rescheduleIntervals();
    },
  },
});

state.simulationsPromise = state.runAsync(async () => {
  let token = localStorage.getItem('de.resol.web-simulation.token');
  if (token == null) {
    token = 'anonymous';
  }

  const simulations = await state.performJsonRpc('getSimulationsByToken', {
    token: token.replace(/--.*$/, ''),
  });

  state.token = token;
  state.simulations = simulations;
  state.simulationsLoaded = true;
});


export default state;
